import { PaginationResponse } from "../types/Common.interface";
import { News } from "../types/News.interface";
import { queryBuilder } from "../utils/url";
import { API } from "./api";

interface GetNewsQuery {
  page: number;
  size: number;
  sort: string;
}

const NewsService = {
  getNews: (query: GetNewsQuery) =>
    API.get<PaginationResponse<News[]>>(
      `/api/news/list${queryBuilder(query)}`
    ).then(({ data }) => data),

  getFirstPageNews: () =>
    API.get(`/api/news/firstPage`).then(({ data }) => data),

  getNewsById: (id) =>
    API.get(`/api/news/getByNumber?number=${id}`).then(({ data }) => data),
};

export default NewsService;
